export default __webpack_public_path__ + "static/article-the-best-time-to-buy-a-new-car-fe916714c24b0cde12842d9b8eee4b0e.jpg";